<div>
    <input class="my-search-box" (keydown.enter)="$event.preventDefault()" #searchPlace label="Buscar Dirección">
</div>

<google-map [options]="options" [center]="center" width="100%">
    <map-marker
        *ngFor="let marker of markers"
        [position]="{ lat: marker.lat, lng: marker.lng }"
        [options]="markerOptions"
        [clickable]="true"></map-marker>
</google-map>



